import styled from 'styled-components';

type Props = {
  $center?: boolean;
};

export const Description = styled.p<Props>`
  text-align: ${({ $center }) => ($center ? 'center' : 'start')};
  margin-bottom: 24px;
`;

export const UserGroupsContainer = styled.div`
  margin-bottom: 32px;
`;

export const IconContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto 24px;
`;
